import {
  User,
  FullName,
  ResetPasswordModel,
  UserChangePassword,
  DeleteAccount,
} from '../models/User'
import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'

interface PhotoResponse extends HttpResponse {
  data: {
    publicId: string
    url: string
  }
}

const Profile = {
  editUser: (user: User) => requests.put<void>('/profile', user),
  editAvatar: (formData: FormData) =>
    requests.post<PhotoResponse>('/profile/editAvatar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  changePassword: (pass: UserChangePassword) =>
    requests.put<HttpResponse>('/profile/changePassword', pass),
  resetPassword: (resetPassword: ResetPasswordModel) =>
    requests.post<HttpResponse>('/profile/resetPassword', resetPassword),
  sendForgotPassword: (email: string) => requests.get(`/profile/sendForgotPassword?email=${email}`),
  sendMessage: (message: any) => requests.post<HttpResponse>('/profile/sendMessage', message),
  deleteAccount: (data: DeleteAccount) => requests.post<HttpResponse>('/profile/delete', data),
}

export default Profile
